import { service } from '../../service';
import { icons } from '../../service/icons';
import i18n from '../../i18n';

const state = {
  themes: [],
  currentTheme: {},
  idChannel: process.env.ID_CHANNEL || 1,
  homeData: [
    { id: 'home', category: 'home', logoSvg: icons.home },
    {
      id: 'trends_recent_all',
      title: i18n.t('categories.trends_recent_all'),
      category: 'trends_recent_all',
      logo: null,
      children: [],
    },
    {
      id: 'popular',
      title: i18n.t('categories.popular'),
      category: 'popular',
      logo: null,
      children: [],
    },
    {
      id: 'all',
      title: i18n.t('categories.all'),
      category: 'all',
      logo: null,
      children: [],
    },
  ],
    nbVideoByTheme:0
};

const mutations = {
  FETCH_THEMES(state, themes) {
    state.themes = themes;
  },
  SET_CURRENT_THEME(state, currentTheme) {
    state.currentTheme = currentTheme;
  },
    SET_NB_VIDEO_BY_THEME(state, nbVideo) {
    state.nbVideoByTheme = nbVideo;
  },
};

const getters = {
  getAllThemes(state) {
    return state.themes;
  },
  getHomeData(state) {
    return state.homeData;
  },
  getCurrentTheme(state) {
    return state.currentTheme;
  },
    getNbVideosByTheme(state) {
    return state.nbVideoByTheme;
  },
};

const actions = {
  async fetchThemes({ commit }, obj) {
    const { data } = await service.getThemesWithChildrenByData(obj);
    const themes = data.themes;
    const home = {
      id: 0,
      logoSvg: icons.home,
    };
    themes.unshift(home);
    commit('FETCH_THEMES', themes);
  },
  async setCurrentThemeDetails({ commit }, id) {
    const { data } = await service.getThemeDetailById(id);
    commit('SET_CURRENT_THEME', data);
  },
    async setNbVideosByTheme({ commit }, nb) {
    commit('SET_NB_VIDEO_BY_THEME', nb);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/themes.js